// extracted by mini-css-extract-plugin
export default {"option":"Option-module-a0fd450961870dab8e6a","color":"Option-module-c42153fe16249767cfaf","label":"Option-module-f65422eab1d69d7a6b67"};